var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSerchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4335 13.3238L15.9255 16.8158C16.1711 17.0614 16.5703 17.0614 16.8158 16.8158C17.0614 16.5703 17.0614 16.1711 16.8158 15.9255L13.3238 12.4335C14.4389 11.1169 15.1114 9.4144 15.1114 7.5557C15.1114 3.38558 11.7258 0 7.5557 0C3.38558 0 0 3.38558 0 7.5557C0 11.7258 3.38558 15.1114 7.5557 15.1114C9.4144 15.1114 11.1169 14.4389 12.4335 13.3238ZM7.5557 1.25928C11.0307 1.25928 13.8521 4.08071 13.8521 7.5557C13.8521 11.0307 11.0307 13.8521 7.5557 13.8521C4.08071 13.8521 1.25928 11.0307 1.25928 7.5557C1.25928 4.08071 4.08071 1.25928 7.5557 1.25928Z",
    fill: "#EF7C32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerchIcon);
export default __webpack_public_path__ + "static/media/serch-icon.6d9d7d76d034e1683b21e0119a3041e9.svg";
export { ForwardRef as ReactComponent };